import * as React from "react";
const SvgFiRrOlive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-olive_svg__a)">
      <path
        fill="#062147"
        d="M21.019 2.981C16.655-1.379 9.062-.887 4.088 4.087 1.697 6.478.257 9.54.03 12.711c-.229 3.225.818 6.175 2.951 8.308 1.995 1.995 4.664 2.974 7.451 2.974 3.308 0 6.78-1.38 9.479-4.08 2.391-2.39 3.831-5.453 4.058-8.624.229-3.225-.817-6.175-2.95-8.308m.956 8.166c-.191 2.691-1.427 5.302-3.477 7.352-4.192 4.193-10.519 4.691-14.103 1.106-1.717-1.717-2.559-4.114-2.37-6.75.191-2.692 1.427-5.303 3.477-7.353 2.312-2.312 5.272-3.5 8.064-3.5 2.271 0 4.431.787 6.038 2.394 1.717 1.717 2.56 4.114 2.371 6.751M17.71 6.29c1.361 1.361 1.7 3.23.755 4.174s-2.813.606-4.174-.755-1.7-3.23-.755-4.174 2.813-.606 4.174.755"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-olive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOlive;
